import { checkResponse } from "src/components/js/statics1";
import asiakasAuthClass from "./asiakasAuthClass";
import keikkaAuthClass from "./keikkaAuthClass";
import tyomaaAuthClass from "./tyomaaAuthClass";

export default class authClass {
  constructor() {
    this.isLoaded = false;
    this.keikkaId = 0;
    this.personId = 0;
    this.tyomaaId = 0;
    this.asiakasId = 0;
    this.keikkaAuth = new keikkaAuthClass();
    this.tyomaaAuth = new tyomaaAuthClass();
    this.asiakasAuth = new asiakasAuthClass();
  }

  init = async (personId, keikkaId, tyomaaId, asiakasId, keikkaTilaId, token) => {
    this.keikkaId = keikkaId || 0;
    this.personId = personId || 0;
    this.tyomaaId = tyomaaId || 0;
    this.asiakasId = asiakasId || 0;
    await this.fetchAuthAsync(personId, keikkaId, tyomaaId, asiakasId, token);
    this.setAuthByKeikkaTilaId(keikkaTilaId);
    this.isLoaded = true;
  };

  resetClass = () => {
    this.keikkaId = 0;
    this.keikkaAuth = new keikkaAuthClass();
    this.tyomaaAuth = new tyomaaAuthClass();
    this.asiakasAuth = new asiakasAuthClass();
    this.isLoaded = false;
  };

  saveKeikkaAuthToDB = async (personId, keikkaId, token, tyomaaId = null, asiakasId = null) => {
    let _read = this.keikkaAuth.read;
    if (tyomaaId > 0) _read = this.tyomaaAuth.read;
    else if (asiakasId > 0) _read = this.asiakasAuth.read;

    let _edit = this.keikkaAuth.edit;
    if (tyomaaId > 0) _edit = this.tyomaaAuth.edit;
    else if (asiakasId > 0) _edit = this.asiakasAuth.edit;

    let _listPersons = this.keikkaAuth.listPersons;
    if (tyomaaId > 0) _listPersons = this.tyomaaAuth.listPersons;
    else if (asiakasId > 0) _listPersons = this.asiakasAuth.listPersons;

    let _addPerson = this.keikkaAuth.addPerson;
    if (tyomaaId > 0) _addPerson = this.tyomaaAuth.addPerson;
    else if (asiakasId > 0) _addPerson = this.asiakasAuth.addPerson;

    let _editPerson = this.keikkaAuth.editPerson;
    if (tyomaaId > 0) _editPerson = this.tyomaaAuth.editPerson;
    else if (asiakasId > 0) _editPerson = this.asiakasAuth.editPerson;

    let _createKeikka = false;
    if (tyomaaId > 0) _createKeikka = this.tyomaaAuth.createKeikka;
    else if (asiakasId > 0) _createKeikka = this.asiakasAuth.createKeikka;

    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: personId,
        keikkaId: keikkaId,
        tyomaaId: tyomaaId,
        asiakasId: asiakasId,
        read: _read,
        edit: _edit,
        listPersons: _listPersons,
        addPerson: _addPerson,
        editPerson: _editPerson,
        createKeikka: _createKeikka,
      }),
    };
    const result = await fetch(import.meta.env.VITE_SERVER_URL + "/api/auth/set", requestOptions);
    return result.ok;
  };
  setAuthByKeikkaTilaId = (keikkaTilaId) => {
    // keikkaTilaId 0 ja 1, ei muutosta
    if (keikkaTilaId <= 1) {
      return;
    }

    if (keikkaTilaId <= 3 && this.keikkaAuth.isKeikkaAdmin) {
      // keikkaTilaId <= 3, odottaa vahvistusta ja aikaisemmat, isKeikkaAdmin voi muokata
      return;
    } else if (keikkaTilaId >= 2) {
      // keikkaTilaId > 1, normikäyttäjä ei muuta tietoja
      this.keikkaAuth.edit = false;
      this.keikkaAuth.listPersons = false;
      this.keikkaAuth.addPerson = false;
    }
  };
  fetchAuthAsync = async (personId = 0, keikkaId = 0, tyomaaId = 0, asiakasId = 0, token) => {
    if (personId === 0) {
      this.resetClass();
      return;
    }
    try {
      const url_auth = "/api/auth/" + personId + "/" + keikkaId + "/" + tyomaaId + "/" + asiakasId;
      const response = await fetch(import.meta.env.VITE_SERVER_URL + url_auth, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      }).catch((err) => console.log(err));
      if (response.status === 401) {
        console.log("UNAUTHORIZED");
        this.resetClass();
        return;
      }
      const cResponse = await checkResponse(response, "authClass.js:fetchAuthAsync");
      if (!cResponse.success) {
        this.resetClass();
        return;
      }
      const authJson = cResponse.data;

      if (response.status > 399) {
        console.log("fetchAuthAsync response.status", response.status);
        console.log(authJson);
        this.resetClass();
        return;
      }
      const jsonData = authJson[0];
      this.asiakasAuth.setAuthDataFromJson(jsonData);
      this.tyomaaAuth.setAuthDataFromJson(jsonData);
      this.keikkaAuth.setAuthDataFromJson(jsonData);
      this.isLoaded = true;
    } catch (err) {
      console.log(err);
    }
  };
}

// fetch auth token from backend
export async function authenticate(email, personId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": 360,
    },
    body: JSON.stringify({
      email: email,
      personId: personId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/auth/authenticate",
    requestOptions
  );
  const cResponse = await checkResponse(response, "auth.js:authenticate");
  if (!cResponse.success) return false;
  return cResponse.data;
}
